import { AdminLocationAlert } from "./schema";
import { LocationAlertData } from "../../../../models/LocationAlert";

export const convertToSchema = (
  locationAlert: LocationAlertData
): AdminLocationAlert => {
  return {
    internal_label_ids: locationAlert.labels.map((label) => label.id),
    type: locationAlert.type,
    details: {
      [locationAlert.type]: locationAlert.details
    },
    notify_on_alert: locationAlert.notify_on_alert
  };
};
